<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <router-link :to="{name:'shipper.dashboard'}" class="navbar-brand">
        {{ companyName }}
      </router-link>
    </div>

    <ul class="navbar-nav mr-auto">
      <span v-if="refresh" class="mt-3 alert alert-primary alert-version">
        <div class="mt-2">
          Nova versão do IntegraCargo, clique
          <span class="badge badge-black cursor-pointer" v-on:click="updatePage">{{$t('placeholders.here')}}</span>
          para atualizar
        </div>
      </span>
    </ul>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <div class="">
        <!--
          <input type="text" class="form-control" placeholder="Search...">
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
        -->
        <!-- You can choose types of search input -->
        <div class="togglebutton switch-change-color mt-4">

          <base-switch v-model="darkModeSw" @input="toggleMode">
            <i class="material-icons icon-for-switch" slot="on">nights_stay</i>
            <i class="material-icons text-white icon-for-switch" slot="off">wb_sunny</i>
          </base-switch>
        </div>
      </div>
      <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          v-model="searchQuery"
          type="text"
          class="form-control"
          id="inlineFormInputGroup"
          placeholder="SEARCH"
        />
      </modal>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div class="row">
            <div class="col">
              <div :class="imageSrc== '/img/placeholder.jpg'? 'photo mt-2':'photo-square'"><img :src="imageSrc"/></div>
            </div>

            <span class="mt-3 material-icons">arrow_drop_down</span>
          </div>
          <p class="d-lg-none">{{ $t('pages.layout.logout') }}</p>
        </template>
        <li class="nav-link">
          <router-link :to="{name:'home.profile'}" class="nav-item dropdown-item">{{ $t('pages.layout.profile') }}</router-link>
        </li>
        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logoutSystem">{{ $t('pages.layout.logout') }}</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal } from '@/resources/components';
  import SidebarToggleButton from '@/resources/layouts/SidebarToggleButton';
  import {mapActions, mapGetters} from "vuex";
  import BaseSwitch from "@/resources/components/BaseSwitch";
  import * as Cookies from "js-cookie";

  export default {
    components: {
      SidebarToggleButton,
      CollapseTransition,
      BaseNav,
      Modal,
      BaseSwitch
    },
    props: {
      refresh: {
        default: false
      }
    },
    created() {
      let docClasses = document.body.classList;
      if (this.darkMode == 'true') {
        docClasses.remove('white-content');
      } else {
        docClasses.add('white-content');
      }
      this.darkModeSw = this.darkMode=='true';
      this.companyName = this.token.user.company.fantasy_name
    },
    computed: {
      ...mapGetters({
        darkMode: "getColor"
      }),
      token() {
        return Cookies.getJSON("token");
      },
      routeName() {
        const { name } = this.$route;
        return this.$t('pages.shipper.title.'+name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      },
      imageSrc(){
        if(this.token.user.company.avatar_path){

          return this.base+'/'+this.token.user.company.avatar_path;
        }else{
          return "/img/placeholder.jpg"
        }
      }
    },
    data() {
      return {
        companyName: '',
        darkModeSw: this.darkMode,
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
      };
    },
    methods: {
      ...mapActions(["logout","setColorCookie"]),
      toggleMode(type) {
        this.setColorCookie(type);
        let docClasses = document.body.classList;
        if (type) {
          docClasses.remove('white-content');
        } else {
          docClasses.add('white-content');
        }
        this.darkModeSw =type;
      },
      async logoutSystem(){
        await this.logout();
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      updatePage(){
        this.$emit('update-page')
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
  .icon-for-switch{
    line-height: inherit;
  }
</style>
